import { apiClient as api } from "./httpClient";

// Catálogo de CIDs (tenant, ~12,4 mil linhas sincronizadas do legado). A busca é
// server-side: subcategoria (ex.: F840) ou trecho da descrição, só ativos, até 20 itens.

export interface CidOption {
  id: string;
  /** código, ex.: F840 */
  cidSubCategory: string;
  cidDescription: string;
}

export const cidsService = {
  search: async (term: string): Promise<CidOption[]> => {
    const response = await api.get("/cids/search", { params: { term } });
    return response.data.items;
  },
};
